export const ALLOWED_CODE_ACTES = {
	"AN1-DEPOT": {
		title: "Dépôt du texte",
		order: 0,
		showAgenda: false,
		showAmendements: false,
		codesCurrentActe: ["AN1-DEPOT"],
	},
	AN1: {
		title: "1ère lecture",
		codeActeDecision: "AN1-DEBATS-DEC",
		order: 1,
	},
	"AN1-COM-FOND-SAISIE": {
		title: "Examen en commission",
		parent: "AN1",
		codesCurrentActe: [
			"AN1-COM-FOND-REUNION",
			"AN1-COM-AVIS-REUNION",
			"AN1-COM-FOND-SAISIE",
			"AN1-COM-FOND-NOMIN",
			"AN1-COM-FOND-RAPPORT",
		],
	},
	"AN1-DEBATS-SEANCE": {
		title: "Discussion en séance",
		parent: "AN1",
		codesCurrentActe: ["AN1-DEBATS-SEANCE", "AN1-DEBATS-DEC"],
	},
	AN2: {
		title: "2ème lecture",
		codeActeDecision: "AN2-DEBATS-DEC",
	},
	"AN2-COM-FOND-SAISIE": {
		title: "Examen en commission",
		parent: "AN2",
		codesCurrentActe: [
			"AN2-COM-FOND-REUNION",
			"AN2-COM-AVIS-REUNION",
			"AN2-COM-FOND-SAISIE",
			"AN2-COM-FOND-NOMIN",
			"AN2-COM-FOND-RAPPORT",
		],
	},
	"AN2-DEBATS-SEANCE": {
		title: "Discussion en séance",
		parent: "AN2",
		codesCurrentActe: ["AN2-DEBATS-SEANCE", "AN1-DEBATS-DEC"],
	},
	ANLUNI: {
		title: "Lecture unique",
		codeActeDecision: "ANLUNI-DEBATS-DEC",
		order: 1,
		hideIfNoSteps: true,
	},
	"ANLUNI-DEPOT": {
		title: "Dépôt du texte",
		order: 0,
		showAgenda: false,
		showAmendements: false,
		codesCurrentActe: ["ANLUNI-DEPOT", "ANLUNI-RTRINI"],
	},
	"ANLUNI-COM-CAE-SAISIE": {
		title: "Examen en commission",
		parent: "ANLUNI",
		codesCurrentActe: [
			"ANLUNI-COM-CAE-SAISIE",
			"ANLUNI-COM-CAE-REUNION",
			"ANLUNI-COM-CAE-NOMIN",
		],
	},
	"ANLUNI-COM-FOND-SAISIE": {
		title: "Examen en commission",
		parent: "ANLUNI",
		codesCurrentActe: [
			"ANLUNI-COM-FOND-REUNION",
			"ANLUNI-COM-AVIS-REUNION",
			"ANLUNI-COM-CAE-SAISIE",
			"ANLUNI-COM-FOND-SAISIE",
			"ANLUNI-COM-FOND-NOMIN",
			"ANLUNI-COM-FOND-RAPPORT",
		],
	},
	"ANLUNI-DEBATS-SEANCE": {
		title: "Discussion en séance",
		parent: "ANLUNI",
		codesCurrentActe: ["ANLUNI-DEBATS-SEANCE", "ANLUNI-DEBATS-DEC"],
	},
	ANNLEC: {
		title: "Nouvelle lecture",
		codeActeDecision: "ANNLEC-DEBATS-DEC",
		order: 1,
	},
	"ANNLEC-COM-FOND-SAISIE": {
		title: "Examen en commission",
		parent: "ANNLEC",
		codesCurrentActe: [
			"ANNLEC-COM-FOND-REUNION",
			"ANNLEC-COM-AVIS-REUNION",
			"ANNLEC-COM-FOND-SAISIE",
			"ANNLEC-COM-FOND-NOMIN",
		],
	},
	"ANNLEC-DEBATS": {
		title: "Discussion en séance",
		parent: "ANNLEC",
		codesCurrentActe: ["ANNLEC-DEBATS", "ANNLEC-DEBATS-DEC"],
	},
	"AN20-RAPPORT": {
		title: "Dépôt de rapport",
		showAgenda: false,
		showAmendements: false,
		showExposeMotifs: false,
		codesCurrentActe: ["AN20-RAPPORT"],
	},
	"SN1-DEPOT": {
		title: "Dépôt du texte",
		order: 0,
		showAgenda: false,
		showAmendements: false,
		codesCurrentActe: ["SN1-DEPOT"],
	},
	SN1: {
		title: "1ère lecture",
		codeActeDecision: "SN1-DEBATS-DEC",
		order: 1,
	},
	"SN1-COM-FOND-SAISIE": {
		title: "Examen en commission",
		parent: "SN1",
		codesCurrentActe: [
			"SN1-COM-FOND-REUNION",
			"SN1-COM-AVIS-REUNION",
			"SN1-COM-FOND-SAISIE",
			"SN1-COM-FOND-NOMIN",
			"SN1-COM-FOND-RAPPORT",
		],
	},
	"SN1-DEBATS": {
		title: "Discussion en séance",
		parent: "SN1",
		codesCurrentActe: ["SN1-DEBATS", "SN1-DEBATS-DEC"],
	},
	SN2: {
		title: "2ème lecture",
		codeActeDecision: "SN2-DEBATS-DEC",
	},
	"SN2-COM-FOND-SAISIE": {
		title: "Examen en commission",
		parent: "SN2",
		codesCurrentActe: [
			"SN2-COM-FOND-REUNION",
			"SN2-COM-AVIS-REUNION",
			"SN2-COM-FOND-SAISIE",
			"SN2-COM-FOND-NOMIN",
			"SN2-COM-FOND-RAPPORT",
		],
	},
	"SN2-DEBATS": {
		title: "Discussion en séance",
		parent: "SN2",
		codesCurrentActe: ["SN2-DEBATS", "SN2-DEBATS-DEC"],
	},
	SNNLEC: {
		title: "Nouvelle lecture",
		codeActeDecision: "ANNLEC-DEBATS-DEC",
		order: 1,
	},
	"SNNLEC-COM-FOND-SAISIE": {
		title: "Examen en commission",
		parent: "SNNLEC",
		codesCurrentActe: [
			"SNNLEC-COM-FOND-REUNION",
			"SNNLEC-COM-AVIS-REUNION",
			"SNNLEC-COM-FOND-SAISIE",
			"SNNLEC-COM-FOND-NOMIN",
		],
	},
	"SNNLEC-DEBATS-SEANCE": {
		title: "Discussion en séance",
		parent: "SNNLEC",
		codesCurrentActe: ["SNNLEC-DEBATS", "SNNLEC-DEBATS-DEC"],
	},
	CMP: {
		title: "Commission mixte paritaire",
		codeActeDecision: "CMP-DEC",
	},
	"CMP-SAISIE": {
		title: "Composition de la CMP",
		parent: "CMP",
		codesCurrentActe: ["CMP-SAISIE"],
	},
	"CMP-DEC": {
		title: "Travaux en commission",
		parent: "CMP",
		codesCurrentActe: [
			"CMP-DEC",
			"CMP-DEBATS-AN-DEC",
			"CMP-COM-RAPPORT-AN",
			"CMP-COM-RAPPORT-SN",
		],
	},
	// "CMP-DEBATS-AN": {
	// 	title: "Lecture et vote",
	// 	parent: "CMP",
	// 	codesCurrentActe: ["CMP-DEBATS-AN"],
	// },
	CC: {
		title: "Conseil constitutionnel",
	},
	"CC-SAISIE-AN": {
		title: "Décision",
		parent: "CC",
		codesCurrentActe: ["CC-SAISIE-AN"],
	},
	"CC-SAISIE-DROIT": {
		title: "Décision",
		parent: "CC",
		codesCurrentActe: ["CC-SAISIE-DROIT"],
	},
	"PROM-PUB": {
		title: "Promulgation",
		showAgenda: false,
		showAmendements: false,
		codesCurrentActe: ["PROM-PUB"],
	},
};
